<template>
	<div class="follower-calendar">
		<vx-card>
			<vs-tabs v-model="tab">
				<vs-tab :label="$t('Follower.FollowersList')" icon-pack="feather" icon="icon-info"> </vs-tab>
				<vs-tab :label="title" icon-pack="feather" icon="icon-list"> </vs-tab>
			</vs-tabs>

			<!-- <router-view></router-view> -->
		</vx-card>
	</div>
</template>

<script>
import FollowerForm from "./FollowerForm.vue";
import FollowerList from "./FollowerList.vue";

export default {
	name: "FollowerCalendar",
	components: {
		FollowerList,
		FollowerForm,
	},
	data() {
		return {
			activeTab: "create",
			tab: 0,
		};
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		async fetchCompanyConfigList() {
			try {
				this.openLoading();
				const response = await this.$store.dispatch("moduleCompanyConfig/fetchCompanyConfigList");
			} catch (error) {
				console.error("fetchCompanyConfigList", error);
			} finally {
				this.closeLoading();
			}
		},
	},
	computed: {
		// Add your component computed properties here
		routePath() {
			return this.$route.path;
		},
		currentRoute() {
			return this.routePath.split("/").pop();
		},
		title() {
			return this.$t("Follower.FollowerConfiguration");
		},
	},

	watch: {
		// Add your watch properties here
		tab(val) {
			if (val === 0) {
				this.$router.push("/apps/calendar/follower/list");
			} else {
				this.$router.push("/apps/calendar/follower/create");
			}
		},
	},
	mounted() {
		// Add your mounted logic here
		this.activeTab = this.currentRoute;

		if (this.currentRoute.includes("list")) {
			this.tab = 0;
		}
	},

	created() {
		// component created hook
		this.$store.state.moduleCompanyConfig.configList.length === 0 && this.fetchCompanyConfigList();
	},
};
</script>

<style scoped>
.follower-calendar {
	/* Add your component styles here */
	.text-underline {
		text-decoration: underline;
	}
}
</style>
